import { ForwardedRef } from 'react';

export interface LookupValue<T = string> {
  label: string;
  value: T;
}

export enum MessageLevel {
  Information = 'Information',
  Success = 'Success',
  Warning = 'Warning',
  Error = 'Error',
}

// Work-around type for forwarding refs to generic elements.
// See: https://fettblog.eu/typescript-react-generic-forward-refs/#option-1%3A-type-assertion
export type PropsWithForwardedRef<TProps, TElement> = TProps & { ref?: ForwardedRef<TElement> };
